import {kHomeScreenImages} from "../../../constants/images";

export default function HomePhoneImage() {
    // Used in HomeDownloadMobileApp to display phone image
    // with fox

    // BUILD
    return (
        <div className={"mr-[24px] min-w-[358px] h-[432px] min-h-[432px] flex items-center justify-center"}>
            <img className={"object-contain h-full"}
                 src={kHomeScreenImages.foxWithPhone}
                 alt="Mobile" />
        </div>
    );
}